<template>
<div>
    <test-page-header
        :title="testBeingPassing.name"
        :is-one-line-title="false"
        :return-button="returnButton"
        :is-show-navigation="!isPublicForm"
    />
    <svg class="test-fail-form-icon my-2">
        <use xlink:href="#test-fail-icon"></use>
    </svg>
    <h1 class="has-text-centered is-bold">{{ failMessage }}</h1>
</div>
</template>

<script>
import TestPageHeader from "../TestPageHeader";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "TestFailForm",
    components: {TestPageHeader},
    computed: {
        ...mapGetters('tests', [
            'testBeingPassing',
            'failMessage',
            'trans',
            'isPublicForm',
        ]),
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnToTestListPage,
            }
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestListPage',
        ]),
    },
}
</script>

<style scoped>
.test-fail-form-icon {
    display: block;
    margin: 0 auto;
}
</style>